import { render } from "./TokenRedeemed.vue?vue&type=template&id=36838144"
import script from "./TokenRedeemed.vue?vue&type=script&lang=js"
export * from "./TokenRedeemed.vue?vue&type=script&lang=js"

import exportComponent from "/Users/patricksantner/projects/alpbach-ticketshop-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__